// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader-module--header--1hT-s","dark":"SectionHeader-module--dark--1eO8u","center":"SectionHeader-module--center--1DvmY"};